<template>
    <div class="footer-content">
        <div class="pages">
            <div class="pages-list" v-for="item in pages" :key="item.index" @click="goToPage(item.path)">{{ item.name }}
            </div>
        </div>
        <div class="logo">
            <img src="@/assets/footer-logo.webp" alt="">
            <p>PIXELNOMAD PRIVATE LIMITED</p>
        </div>
        <div class="contact">
            <div v-for="item in list" :key="item.index">
                <img :src="require('@/assets/footerIcon' + item.index + '.webp')" alt="">
                {{ item.content }}
            </div>
        </div>
        <div class="bottom">
            © 2025 Copyright belongs to PIXELNOMAD PRIVATE LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const list = [
    {
        content: "case@pixelnomad-private.com",
        index: 1,
    },
    {
        content: "+91 8145446270",
        index: 2,
    },
    {
        content: "90/12, AB, Malviya Nagar (South Delhi), New Delhi, South Delhi- 110017, Delhi",
        index: 3,
    },
];
const pages = [
    {
        name: "Pages",
    },
    {
        name: "Home",
        path: "/",
    },
    // { 
    //     name: "Services",
    //     path: "/service"
    // },
    // {
    //     name: "Introduction",
    //     path: "/about"
    // },
    {
        name: "Contact Us",
        path: "/contact"
    },
    {
        name: "Lending Partner",
        path: "/partner"
    },
    {
        name: "Private Policy",
        path: "/privatePolicy",
    },
    {
        name: "Loan Agreement",
        path: "/loanAgreement",
    },
];
const goToPage = (path) => {
    router.replace(path);
    scroll(0, 0);
}
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 291px;
    background: #023B80;
    padding: 38px 270px 20px;
    box-sizing: border-box;
    position: relative;
    z-index: 0;

    .pages {
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 26px;

        .pages-list {
            font-weight: 400;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 14px;
            cursor: pointer;
        }
    }

    .logo {
        display: flex;
        align-items: center;
        margin-bottom: 27px;

        img {
            width: 45px;
            height: 45px;
            object-fit: cover;
            margin-right: 8px;
        }

        p {
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
        }
    }

    .contact {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding-bottom: 28px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        &>div:nth-child(3) {
            width: 313px;
        }

        div {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 14px;
            text-shadow: 0px 1px 0px #333333;

            img {
                width: 18px;
                height: 18px;
                object-fit: contain;
                margin-right: 8px;
            }
        }
    }

    .bottom {
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>